import { render } from "./bidding.vue?vue&type=template&id=8bd37240&scoped=true"
import script from "./bidding.vue?vue&type=script&lang=js"
export * from "./bidding.vue?vue&type=script&lang=js"

import "./bidding.vue?vue&type=style&index=0&id=8bd37240&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd37240"]])

export default __exports__